/**
 * CardWidget — casca dos widgets do dashboard original: card branco com
 * cantos 2xl e header em gradiente com ícone em círculo translúcido.
 */

import type { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactNode } from 'react'

export function CardWidget({
  titulo,
  subtitulo,
  icone,
  gradiente,
  corSubtitulo,
  acoes,
  children,
  className = '',
}: {
  titulo: string
  subtitulo?: string
  icone: IconDefinition
  gradiente: string
  corSubtitulo?: string
  acoes?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={`overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-lg dark:border-slate-700 dark:bg-dark-card ${className}`}
    >
      <div className={`bg-gradient-to-r p-4 ${gradiente}`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20 backdrop-blur">
              <FontAwesomeIcon icon={icone} className="text-lg text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white">{titulo}</h2>
              {subtitulo && (
                <p className={`text-sm ${corSubtitulo ?? 'text-white/80'}`}>{subtitulo}</p>
              )}
            </div>
          </div>
          {acoes}
        </div>
      </div>
      {children}
    </div>
  )
}
